/*
 * @Description: 配置
 * @Author: jin
 * @Date: 2019-10-22 10:01:51
 */
//pc地址
export const pcUrl = 'http://lan.quanruntong.cn'
// export const pcUrl = 'http://192.168.199.127' //测试服

//接口地址
export const apiUrl = pcUrl + '/m/'



// WEBPACK FOOTER //
// ./src/config/index.js